// Author thq
// Date 2023-09-06 00:11:43

class TpmMonitorSpindleLoadTms {
    constructor({
                    id = null,
                    tmsCodeBda = '',
                    tmsIdIesmrs = '',
                    tmsBeginTime = '',
                    tmsEndTime = '',
                    tmsDurationTime = '',
                    tmsStartValue = '',
                    tmsEndValue = '',
                    pwrId = '',
                    pwrOrderCode = '',
                    pwrOperateSeqId = '',
                    pwrOperateSeq = '',
                    pwrActLocationId = '',
                    pwrActLocationName = '',
                    pwrStartTime = '',
                    pwrEndTime = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.tmsCodeBda = tmsCodeBda;
        this.tmsIdIesmrs = tmsIdIesmrs;
        this.tmsBeginTime = tmsBeginTime;
        this.tmsEndTime = tmsEndTime;
        this.tmsDurationTime = tmsDurationTime;
        this.tmsStartValue = tmsStartValue;
        this.tmsEndValue = tmsEndValue;
        this.pwrId = pwrId;
        this.pwrOrderCode = pwrOrderCode;
        this.pwrOperateSeqId = pwrOperateSeqId;
        this.pwrOperateSeq = pwrOperateSeq;
        this.pwrActLocationId = pwrActLocationId;
        this.pwrActLocationName = pwrActLocationName;
        this.pwrStartTime = pwrStartTime;
        this.pwrEndTime = pwrEndTime;
        this.remark = remark;
    }
}

function newEntity() {
    return new TpmMonitorSpindleLoadTms();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'nodeId',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.nodeId',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsCodeBda',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsCodeBda',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'iesmrs',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.iesmrs',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsBeginTime',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsBeginTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsEndTime',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsEndTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsDurationTime',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsDurationTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsStartValue',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsStartValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'tmsEndValue',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.tmsEndValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        // {
        // key: 'pwrStartTime',
        // label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.pwrStartTime',
        // sortable: true,
        // form: {
        // type: 'datetimepicker',
        // modalMultiSelectedType: 'string'
        //                 }
        // },
        // {
        // key: 'pwrEndTime',
        // label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.pwrEndTime',
        // sortable: true,
        // form: {
        // type: 'datetimepicker',
        // modalMultiSelectedType: 'string'
        //                 }
        // },
        {
            key: 'remark',
            label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    nodeIdFilter: '',
    tmsCodeBdaFilter: '',
    tmsIdIesmrsFilter: '',
    iesmrsFilter: '',
    tmsBeginTimeRteFilter: '',
    tmsBeginTimeLteFilter: '',
    tmsEndTimeRteFilter: '',
    tmsEndTimeLteFilter: '',
    tmsEndTimeIsNullFilter: '',
    tmsDurationTimeFilter: '',
    tmsStartValueFilter: '',
    tmsEndValueFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'nodeIdFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.nodeId',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsCodeBdaFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.tmsCodeBda',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsBeginTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.tmsBeginTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsBeginTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.tmsBeginTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsEndTimeRteFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.tmsEndTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsEndTimeLteFilter',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.filter.tmsEndTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
];


const entityFormConfigs = [
    {
        key: 'tmsCodeBda',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsCodeBda',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsIdIesmrs',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsIdIesmrs',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsBeginTime',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsBeginTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsEndTime',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsDurationTime',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsDurationTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsStartValue',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsStartValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'tmsEndValue',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.tmsEndValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pwrStartTime',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.pwrStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'pwrEndTime',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.pwrEndTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.em.statusCollection.tpmMonitorSpindleLoadTms.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    TpmMonitorSpindleLoadTms, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
